export enum DecimalSeperator {
  COMMA = ',',
  POINT = '.',
}
